/**
 * A series with query overrides asks its own question, so the same metric can
 * appear more than once on a chart. Its data is keyed by the series id; every
 * other series keeps the metric id it has always been keyed by.
 */
export const hasQueryOverrides = (
  overrides: V5SeriesQueryOverrides | undefined,
): overrides is V5SeriesQueryOverrides =>
  !!overrides &&
  (!!overrides.isFiltersOverridden ||
    (!!overrides.filters && overrides.filters.length > 0) ||
    (!!overrides.dateOffset && overrides.dateOffset.count > 0) ||
    !!overrides.dateField);

export const getSeriesDataKey = (series: V5ChartDefinitionSeries): string =>
  hasQueryOverrides(series.queryOverrides) ? series.id : series.metricId;

export const findSeriesDef = (
  chartDef: V5ChartDefinition,
  dataKey: string,
): V5ChartDefinitionSeries | undefined =>
  chartDef.series.find((s) => getSeriesDataKey(s) === dataKey);

export const findSeriesDefIndex = (
  chartDef: V5ChartDefinition,
  dataKey: string,
): number => chartDef.series.findIndex((s) => getSeriesDataKey(s) === dataKey);
